import Alert from '@material-ui/lab/Alert'
import AlertTitle from '@material-ui/lab/AlertTitle'
import React from 'react'

interface iError {
  children: React.ReactNode
  title?: string
}

const Error = ({ children, title }: iError) =>
  <Alert severity="error">{title && <AlertTitle>{title}</AlertTitle>} {children}</Alert>

export default Error
